import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import {
    NavigationSidebarComponent,
    type NavigationSection
} from 'sms-dashboard';
import { SafetyStateService } from '../safety-state.service';

@Component({
    selector: 'ff-safety-sidebar',
    standalone: true,
    imports: [CommonModule, NavigationSidebarComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <sms-navigation-sidebar
            [selected]="state.selectedSection()"
            (selectedChange)="selectSection($event)"
        />
    `
})
export class SafetySidebarComponent {
    protected readonly state = inject(SafetyStateService);
    private readonly router = inject(Router);

    constructor() {
        if (this.router.url.startsWith('/safety/incidents')) {
            this.state.setSection('incidents');
        } else if (this.state.selectedSection() === 'incidents') {
            // The dashboard has no incidents view, so fall back to the default
            // section when arriving on /safety from the incidents page.
            this.state.setSection('risk-register');
        }
    }

    protected selectSection(section: NavigationSection): void {
        this.state.setSection(section);

        if (section === 'incidents') {
            void this.router.navigate(['/safety/incidents'], {
                queryParamsHandling: 'merge'
            });
        } else if (this.router.url.startsWith('/safety/incidents')) {
            void this.router.navigate(['/safety'], {
                queryParamsHandling: 'merge'
            });
        }
    }
}
